export default "__VITE_ASSET__B_i78AwK__"